import { HttpPostFunction } from "@lookiero/sty-psp-http";
import { GameByCustomerIdView, ViewGameByCustomerIdResult } from "../../../projection/game/viewGameByCustomerId";

interface HttpGameByCustomerIdView extends GameByCustomerIdView {}

interface HttpGameByCustomerIdViewFunctionArgs {
  readonly httpPost: HttpPostFunction;
}

interface HttpGameByCustomerIdViewFunction {
  (args: HttpGameByCustomerIdViewFunctionArgs): HttpGameByCustomerIdView;
}

const httpGameByCustomerIdView: HttpGameByCustomerIdViewFunction =
  ({ httpPost }) =>
  async ({ customerId, signal }) =>
    await httpPost<ViewGameByCustomerIdResult>({
      endpoint: "/view-game-by-customer-id",
      body: {
        customerId,
      },
      signal,
      result: {
        error: null,
        success: (response) => response,
      },
    });

export { httpGameByCustomerIdView };
